<template>
    <span :title="$t('ProductionProgress.AppointmentModal.Card.TotalTime') || 'Tempo total da OP em aberto'">{{ formattedDuration }}</span>
</template>

<script>
import Vue from "vue";
import { formatDurationHms, isFinishedOperationStatus } from "@/views/pages/operator/utils";

const clock = Vue.observable({ now: Date.now() });
let interval = null;
let users = 0;

export default {
    props: {
        resource: { type: Object, required: true }
    },
    computed: {
        formattedDuration() {
            const status = this.resource.status?.name;
            if (!this.resource.orderId || ["", "não iniciado", "not started"].includes((status || "").trim().toLowerCase())) return "00:00:00";
            const isFinished = isFinishedOperationStatus(status) ||
                ["operação finalizada", "operacao finalizada", "completed", "finalizado", "finalizada", "concluído", "concluido"].includes(((status || "").trim().toLowerCase()));
            const startedAt = Date.parse(this.resource.startTime || (!isFinished ? this.resource.lastEventTime : null));
            if (!Number.isFinite(startedAt)) return "00:00:00";

            if (isFinished) {
                const finishedAt = Date.parse(this.resource.finishedAt || this.resource.lastCompleted || this.resource.lastEventTime);
                const elapsed = Number.isFinite(finishedAt) && finishedAt >= startedAt ? Math.floor((finishedAt - startedAt) / 1000) : 0;
                return formatDurationHms(elapsed, "seconds");
            }
            const elapsed = Math.floor(Math.max(0, clock.now - startedAt) / 1000);
            return formatDurationHms(elapsed, "seconds");
        }
    },
    mounted() {
        if (users++ === 0) {
            clock.now = Date.now();
            interval = setInterval(() => { clock.now = Date.now(); }, 1000);
        }
    },
    beforeDestroy() {
        if (--users === 0) {
            clearInterval(interval);
            interval = null;
        }
    }
};
</script>
